import { FC } from 'react';

import { Button, Modal } from 'antd';

import { useTranslation } from 'react-i18next';
import styles from './UnsubscribeModal.module.scss';

interface UnsubscribeModalProps {
  open: boolean;
  onCancel: () => void;
  onUnsubscribe: () => void;
  isLoading?: boolean;
}

const UnsubscribeModal: FC<UnsubscribeModalProps> = ({
  open,
  onCancel,
  onUnsubscribe,
  isLoading = false
}: UnsubscribeModalProps) => {
  const { t } = useTranslation()

  return (
    <Modal open={open} onCancel={onCancel} footer={null} width={600}>
      <div className={styles.wrap}>
        <h3 className={styles.title}>
          {t('modal.unsubscribe.areYouSure')}
        </h3>
        <p className={styles.description}>{t('modal.unsubscribe.cancellingWill')}</p>
        <ul className={styles.consequencesList}>
          <li className={styles.consequenceItem}>
            {t('modal.unsubscribe.jobInactive')}
          </li>
          <li className={styles.consequenceItem}>
            {t('modal.unsubscribe.disablePremium')}
          </li>
          <li className={styles.consequenceItem}>
            {t('modal.unsubscribe.preventNew')}
          </li>
        </ul>
        <p className={styles.note}>
          {t('modal.unsubscribe.applicantsAreSaved')}
        </p>
      </div>
      <Button
        key="unsubscribe"
        type="primary"
        onClick={onUnsubscribe}
        className={styles.unsubscribeButton}
        loading={isLoading}
      >
        {t('modal.unsubscribe.cancel')}
      </Button>
    </Modal>
  );
};

export default UnsubscribeModal;
